import { Loader } from '@bgzt/ui';

import styles from './AppLoader.module.css';
export const AppLoader = () => {
  return (
    <div className={styles.container}>
      <Loader size={32} />
    </div>
  );
};
